import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Search } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, eur, formatApiError } from "@/lib/api";
import { IMP_STATUS } from "@/lib/imp";

export const ImpBadge = ({ status }) => {
  const [l, c] = IMP_STATUS[status] || IMP_STATUS.bozza;
  return <span className={`shrink-0 text-[11px] font-semibold px-2.5 py-1 rounded-full border ${c}`} data-testid="imp-status-badge">{l}</span>;
};

export default function Impegnative() {
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const [tab, setTab] = useState("attive");
  const [list, setList] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/impegnative", { params: { q, status: tab === "annullate" ? "annullata" : status } });
      setList(tab === "annullate" ? data : data.filter((m) => m.status !== "annullata"));
    } catch (e) {
      toast.error(formatApiError(e));
    }
  }, [q, status, tab]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    const i = setInterval(load, 15000);
    return () => { clearTimeout(t); clearInterval(i); };
  }, [load]);

  return (
    <div className="space-y-8">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 fade-up">
        <div><p className="eyebrow">Vendita e consegna</p><h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">Impegnative</h1></div>
        <Link to="/impegnative/nuova" className="btn-primary h-11 px-5" data-testid="new-imp-button"><Plus className="h-5 w-5" /> Nuova impegnativa</Link>
      </div>
      <div className="flex gap-2" data-testid="imp-tabs">
        {[["attive", "Da firmare e concordate"], ["annullate", "Annullate"]].map(([k, l]) => (
          <button key={k} onClick={() => { setTab(k); setStatus(""); setList(null); }} data-testid={`imp-tab-${k}`}
            className={`h-10 px-4 rounded-full text-sm font-semibold border transition-colors ${tab === k ? "bg-[var(--ink)] text-white border-[var(--ink)]" : "bg-white border-[var(--border)]"}`}>{l}</button>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[var(--muted)]" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca per nome, cognome o numero (IMP-...)" className="pl-9 h-11 bg-white" data-testid="imp-search-input" />
        </div>
        {tab === "attive" && <select value={status} onChange={(e) => setStatus(e.target.value)} className="h-11 rounded-full border border-[var(--border)] px-4 text-sm bg-white" data-testid="imp-status-filter">
          <option value="">Tutti gli stati</option>
          {Object.entries(IMP_STATUS).filter(([k]) => k !== "annullata").map(([k, [l]]) => <option key={k} value={k}>{l}</option>)}
        </select>}
      </div>
      {list === null ? <p className="text-[var(--muted)]">Caricamento...</p> : list.length === 0 ? (
        <div className="rounded-2xl border border-dashed p-12 text-center text-[var(--muted)]" data-testid="imp-empty">Nessuna impegnativa trovata.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="imp-list">
          {list.map((m) => {
            const v = m.versions[m.versions.length - 1];
            return (
              <Link key={m.id} to={`/impegnative/${m.id}`} className="card-lift block rounded-2xl bg-white border border-[var(--border)] p-5" data-testid={`imp-card-${m.number}`}>
                <div className="flex items-start justify-between gap-2 mb-2"><p className="font-mono text-sm font-semibold">{m.number}</p><ImpBadge status={m.status} /></div>
                <p className="font-heading text-lg font-semibold truncate">{m.customer_name}</p>
                <p className="text-xs text-[var(--muted)]">{new Date(m.created_at).toLocaleDateString("it-IT")} · v{m.current_version} · {m.created_by}</p>
                <div className="mt-3 pt-3 border-t border-dashed flex justify-between text-sm font-mono"><span>Totale {eur(v.totals.total)}</span><span className="text-[var(--primary-hover)]">Saldo {eur(v.totals.balance)}</span></div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
